export default "__VITE_ASSET__hPuNtBuV__"